import type { GeometryPadWidgetConfig } from '../geometrypad.model';

export const SINGLE_TRIANGLE_PRESET: GeometryPadWidgetConfig = {
  id: 'single-triangle',
  type: 'geometrypad',
  params: {
    elements: {
      t1: {
        type: 'Triangle',
        params: { a: 5, b: 7, gamma: 50 },
      },
    },
  },
  display: {
    geometry: {
      shape: { coloring: false },
      label: { coloring: true },
    },
  },
  behavior: {
    interactive: ['t1.point.A', 't1.point.B', 't1.point.C'],
  },
};
